/**
 * Base error class that extends the native {@link Error} with an optional
 * {@link BaseError.isExpected | isExpected} flag.
 *
 * Use this class (or a subclass) when you need to distinguish anticipated
 * failures (e.g. validation errors, user-facing issues) from truly unexpected
 * ones.  Consumers can inspect {@link BaseError.isExpected} to decide whether
 * to surface a notification, log silently, or take a different recovery path.
 */ export class BaseError extends Error {
    /**
     * Creates a new {@link BaseError}.
     *
     * @param message - Optional human-readable description of the error.
     * @param isExpected - Optional flag that marks the error as anticipated.
     */ constructor(message, isExpected){
        super(message);
        this.name = "BaseError";
        this.isExpected = isExpected;
    }
}
